require('./club-hole-by-hole-detail.jade')
_ = require("lodash")

ClubHoleByHoleDetailDirective = ($filter)->
  templateUrl: "club/club-hole-by-hole/club-hole-by-hole-detail.jade"
  scope:
    analysis: '=analysis'
    course: '=course'
    selected: '=selected'

ClubHoleByHoleDetailDirective.$inject = [
  "$filter"
]

module.exports = ClubHoleByHoleDetailDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-hole-by-hole/club-hole-by-hole-detail-directive.coffee